const PATIENT_FIELDS = [
  { key: 'mrn', label: 'MRN', section: 'personal', required: true, visible: true},
  { key: 'room', label: 'Room', section: 'personal', visible: true},
  { key: 'first_name', label: 'First Name', section: 'personal', required: true, visible: true},
  { key: 'middle_name', label: 'Middle Name', section: 'personal', visible: true},
  { key: 'last_name', label: 'Last Name', section: 'personal', required: true, visible: true},
  { key: 'suffix', label: 'Suffix', section: 'personal', visible: true},
  { key: 'dob', label: 'Date of Birth', section: 'personal', visible: true},
  { key: 'gender', label: 'Gender', section: 'personal', required: true, visible: true},
  { key: 'active', label: 'Active', section: 'personal', visible: true},
  { key: 'virtual_status', label: 'Virtual Status', section: 'personal', visible: true},

  { key: 'pain_scale', label: 'Pain Scale', section: 'digital_signs', visible: true},
  { key: 'precautions', label: 'Precautions', section: 'digital_signs', visible: true},
  { key: 'family_note', label: 'Family Note', section: 'digital_signs', visible: true},
  { key: 'room_note', label: 'Room Note', section: 'digital_signs', visible: true},

  { key: 'pronoun', label: 'Pronoun', section: 'general', visible: true},
  { key: 'language', label: 'Language', section: 'general', visible: true},
  { key: 'note', label: 'Note', section: 'general', visible: true},
  { key: 'attributes', label: 'Attributes', section: 'general', visible: true },
  { key: 'aimee_memory_personal', label: 'Aimee Personal Memory', section: 'general', visible: true },
  { key: 'aimee_memory_clinical', label: 'Aimee Clinical Memory', section: 'general', visible: true }
]

export const FIELD_CONFIGS = {
  patients: {
    sections: [
      { key: 'personal', label: 'Personal', visible: true},
      { key: 'digital_signs', label: 'Digital Signs & Family Connect', visible: true},
      { key: 'general', label: 'General', visible: true}
    ],
    fields: PATIENT_FIELDS
  }
}

function initializeFieldVisibility(mergedConfig) {
  const visibility = {
    sections: {},
    fields: {}
  }

  mergedConfig.sections.forEach(section => {
    visibility.sections[section.key] = {
      visible: section.visible ?? true,
      label: section.label
    }
  })

  mergedConfig.fields.forEach(field => {
    visibility.fields[field.key] = {
      visible: field.visible ?? true,
      required: field.required || false,
      section: field.section,
      label: field.label
    }
  })

  return visibility
}

export function getFieldVisibility(pageType, store) {
  const staticConfig = FIELD_CONFIGS[pageType]
  const customFields = Object.values(store.getters["CustomFieldsStore/getFieldsFor"]('Patient'))

  const sections = [...staticConfig.sections]
  const fields = [...staticConfig.fields]

  customFields.forEach(field => {
    const sectionKey = `custom_section_${field.section.toLowerCase().replace(/\s+/g, '_')}`

    if (!sections.find(s => s.key === sectionKey)) {
      sections.push({
        key: sectionKey,
        label: field.section,
        visible: true
      })
    }

    fields.push({
      key: `custom_${field.key}`,
      label: field.label || field.title || field.name,
      section: sectionKey,
      required: field?.options?.validation?.isRequired || false,
      visible: true
    })
  })

  return initializeFieldVisibility({ sections, fields })
}